module.exports = __webpack_public_path__ + "img/cover17.c5ae14ed.png";